import { StyleSheet } from '@react-pdf/renderer';
import {
  baseWhite,
  inkDarkest,
  inkLighter,
  primaryBase,
  secondaryBase,
  skyBase,
  skyDark,
  skyLight,
  skyLighter,
  textCaseUppercase,
} from '../../../../styles/design-tokens';

const pdfStyles = StyleSheet.create({
  page: {
    paddingTop: 48,
    paddingBottom: 64,
    paddingHorizontal: 48,
    backgroundColor: baseWhite,
    fontFamily: 'Helvetica',
    fontSize: 11,
    color: inkDarkest,
  },
  header: {
    marginBottom: 28,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: skyLight,
    borderBottomStyle: 'solid',
  },
  headerTitle: {
    fontSize: 18,
    fontFamily: 'Helvetica-Bold',
    color: inkDarkest,
    marginBottom: 4,
  },
  headerDate: {
    fontSize: 9,
    color: skyDark,
  },
  messagePair: {
    marginBottom: 24,
  },
  userLabel: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: primaryBase,
    marginBottom: 5,
    textTransform: textCaseUppercase,
    letterSpacing: 0.5,
  },
  userText: {
    fontSize: 11,
    color: inkDarkest,
    lineHeight: 1.55,
    marginBottom: 12,
  },
  assistantLabel: {
    fontSize: 9,
    fontFamily: 'Helvetica-Bold',
    color: secondaryBase,
    marginBottom: 6,
    textTransform: textCaseUppercase,
    letterSpacing: 0.5,
  },
  divider: {
    borderTopWidth: 1,
    borderTopColor: skyLighter,
    borderTopStyle: 'solid',
    marginBottom: 12,
  },
  heading1: {
    fontSize: 16,
    fontFamily: 'Helvetica-Bold',
    color: inkDarkest,
    marginBottom: 8,
    marginTop: 14,
  },
  heading2: {
    fontSize: 13,
    fontFamily: 'Helvetica-Bold',
    color: inkDarkest,
    marginBottom: 6,
    marginTop: 10,
  },
  heading3: {
    fontSize: 11,
    fontFamily: 'Helvetica-Bold',
    color: '#222222',
    marginBottom: 4,
    marginTop: 8,
  },
  paragraph: {
    fontSize: 11,
    lineHeight: 1.6,
    marginBottom: 8,
    color: '#222222',
  },
  listRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  listBullet: {
    width: 14,
    fontSize: 11,
    color: '#555555',
  },
  listItemText: {
    flex: 1,
    fontSize: 11,
    lineHeight: 1.5,
    color: '#222222',
  },
  codeBlock: {
    fontFamily: 'Courier',
    fontSize: 9.5,
    backgroundColor: skyLighter,
    padding: 10,
    marginTop: 4,
    marginBottom: 10,
  },
  artifactSection: {
    marginTop: 14,
    marginBottom: 4,
  },
  artifactLabel: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: '#333333',
    marginBottom: 6,
  },
  artifactImage: {
    width: '100%',
    marginBottom: 10,
  },
  table: {
    marginTop: 4,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: skyBase,
    borderStyle: 'solid',
  },
  tableHeaderRow: {
    flexDirection: 'row',
    backgroundColor: skyLighter,
  },
  tableRow: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderTopColor: skyBase,
    borderTopStyle: 'solid',
  },
  tableHeaderCell: {
    flex: 1,
    padding: 5,
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 1,
    borderRightColor: skyBase,
    borderRightStyle: 'solid',
  },
  tableCell: {
    flex: 1,
    padding: 5,
    fontSize: 9.5,
    borderRightWidth: 1,
    borderRightColor: skyBase,
    borderRightStyle: 'solid',
  },
  tableCellLast: {
    flex: 1,
    padding: 5,
    fontSize: 9.5,
    borderRightWidth: 0,
  },
  tableHeaderCellLast: {
    flex: 1,
    padding: 5,
    fontSize: 9.5,
    fontFamily: 'Helvetica-Bold',
    borderRightWidth: 0,
  },
  horizontalRule: {
    borderTopWidth: 1,
    borderTopColor: skyBase,
    borderTopStyle: 'solid',
    marginTop: 10,
    marginBottom: 10,
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 48,
    right: 48,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderTopWidth: 1,
    borderTopColor: skyLight,
    borderTopStyle: 'solid',
    paddingTop: 8,
  },
  footerLogo: {
    width: 14,
    height: 14,
    marginRight: 6,
  },
  footerText: {
    fontSize: 8,
    color: inkLighter,
  },
});

export { pdfStyles };
